import { qrCodeAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

// The size is driven by the `--qr-code-size` CSS variable that the `frame` slot
// sizes off. The `size` variant sets that variable to a preset, and
// `defaultVariants` guarantees a value so the component is never broken when no
// size is passed. Consumers who need an arbitrary size can still override the
// variable directly (`<QrCode.Root css={{ '--qr-code-size': '160px' }} />`) —
// the `css` prop wins over the variant.
const qrCodeSlotRecipe = defineSlotRecipe({
  slots: qrCodeAnatomy.keys(),
  className: 'chakra-qr-code',
  base: {
    root: {
      position: 'relative',
      width: 'fit-content',
      // A QR must be dark modules on a light surface to scan reliably. Bake the
      // default contrast in (dark foreground + light surface) so consumers get a
      // scannable code from `<QrCode.Root value size>` alone; both are plain
      // style props, so an unusual case can still override them. `icon/primary`
      // (not `text/primary`) because the pattern is a graphic mark, not text.
      // Neither token flips (the theme is light-only), which is what a QR needs.
      color: 'icon/primary',
      backgroundColor: 'background/primary',
      '--qr-code-overlay-size': 'calc(var(--qr-code-size) / 3)',
    },
    frame: {
      // The pattern draws with `currentColor` (the root's `color`), on the
      // root's light `backgroundColor`. The frame itself stays transparent.
      width: 'var(--qr-code-size)',
      height: 'var(--qr-code-size)',
      fill: 'currentColor',
    },
    overlay: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'var(--qr-code-overlay-size)',
      height: 'var(--qr-code-overlay-size)',
      padding: '1',
      backgroundColor: 'background/primary',
      borderRadius: '4',
    },
  },
  variants: {
    size: {
      '104': { root: { '--qr-code-size': '104px' } },
      '240': { root: { '--qr-code-size': '240px' } },
    },
  },
  defaultVariants: {
    size: '104',
  },
});

export default qrCodeSlotRecipe;
